/**
 * サイトロゴのオープニングアニメーションを制御する関数
 * セッションストレージを使用して、初回訪問時のみ実行する
 */
export const initLogoLoader = () => {
	const loader = document.getElementById("js-loader");
	const storageKey = "loading_done";

	// ローダーが存在しない、またはセッションに記録がある場合は何もしない
	if (!loader || sessionStorage.getItem(storageKey)) {
		if (loader) loader.style.display = "none";
		return;
	}

	// 初回訪問時の処理
	loader.style.display = "flex";

	// 2秒間表示してからフェードアウト（1秒かけて消える）
	setTimeout(() => {
		// CSS transitionを利用したフェードアウト
		loader.style.transition = "opacity 1s ease, visibility 1s";
		loader.style.opacity = "0";
		loader.style.visibility = "hidden";

		// アニメーション完了後に非表示にしてフラグを立てる
		setTimeout(() => {
			loader.style.display = "none";
			sessionStorage.setItem(storageKey, "true");
		}, 1000);
	}, 2000);
};

// 実行
initLogoLoader();
